/* tslint:disable */
/* eslint-disable */
/**
 * AIS Coverage API
 * API for managing AIS source identifiers and calculating coverage.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewSourceIdentifier
 */
export interface NewSourceIdentifier {
    /**
     * Maritime Mobile Service Identity (MMSI).
     * @type {number}
     * @memberof NewSourceIdentifier
     */
    pssMmsi: number;
    /**
     * Country Maritime Identification Digits (MID).
     * @type {number}
     * @memberof NewSourceIdentifier
     */
    countryMid: number;
    /**
     * Region identifier.
     * @type {number}
     * @memberof NewSourceIdentifier
     */
    regionId: number;
    /**
     * Source tag or identifier string.
     * @type {string}
     * @memberof NewSourceIdentifier
     */
    sourceTag: string;
}

/**
 * Check if a given object implements the NewSourceIdentifier interface.
 */
export function instanceOfNewSourceIdentifier(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pssMmsi" in value;
    isInstance = isInstance && "countryMid" in value;
    isInstance = isInstance && "regionId" in value;
    isInstance = isInstance && "sourceTag" in value;

    return isInstance;
}

export function NewSourceIdentifierFromJSON(json: any): NewSourceIdentifier {
    return NewSourceIdentifierFromJSONTyped(json, false);
}

export function NewSourceIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewSourceIdentifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pssMmsi': json['pss_mmsi'],
        'countryMid': json['country_mid'],
        'regionId': json['region_id'],
        'sourceTag': json['source_tag'],
    };
}

export function NewSourceIdentifierToJSON(value?: NewSourceIdentifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pss_mmsi': value.pssMmsi,
        'country_mid': value.countryMid,
        'region_id': value.regionId,
        'source_tag': value.sourceTag,
    };
}

